import React from 'react';
import { HiLightBulb, HiExclamationCircle, HiInformationCircle, HiQuestionMarkCircle } from 'react-icons/hi2';

const InfoBox = ({ type = 'info', title, children }) => {
  const styles = {
    reflexe: {
      border: 'border-teal-400 dark:border-teal-600',
      bg: 'bg-teal-50 dark:bg-teal-900/30',
      icon: HiLightBulb,
      iconColor: 'text-teal-600 dark:text-teal-400',
      titleColor: 'text-teal-900 dark:text-teal-300'
    },
    important: {
      border: 'border-orange-400 dark:border-orange-600',
      bg: 'bg-orange-50 dark:bg-orange-900/30',
      icon: HiExclamationCircle,
      iconColor: 'text-orange-600 dark:text-orange-400',
      titleColor: 'text-orange-900 dark:text-orange-300'
    },
    demander: {
      border: 'border-teal-500 dark:border-teal-600',
      bg: 'bg-teal-500 dark:bg-teal-700',
      icon: HiQuestionMarkCircle,
      iconColor: 'text-white',
      titleColor: 'text-white',
      textColor: 'text-white'
    },
    conseil: {
      border: 'border-orange-500 dark:border-orange-600',
      bg: 'bg-orange-500 dark:bg-orange-700',
      icon: HiInformationCircle,
      iconColor: 'text-white',
      titleColor: 'text-white',
      textColor: 'text-white'
    },
    info: {
      border: 'border-gray-300 dark:border-gray-600',
      bg: 'bg-gray-50 dark:bg-gray-800',
      icon: HiInformationCircle,
      iconColor: 'text-gray-600 dark:text-gray-400',
      titleColor: 'text-gray-900 dark:text-white dark:text-white'
    }
  };

  const style = styles[type] || styles.info;
  const Icon = style.icon;

  return (
    <div className={`${style.border} ${style.bg} border-s-4 p-4 rounded-e-lg my-4`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Icon className={`h-6 w-6 ${style.iconColor}`} aria-hidden="true" />
        </div>
        <div className="ms-3 flex-1">
          {title && (
            <h3 className={`text-sm font-bold ${style.titleColor} mb-2`}>
              {title}
            </h3>
          )}
          <div className={`text-sm ${style.textColor || 'text-gray-700 dark:text-gray-300'}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
